module.exports = __webpack_public_path__ + "img/sketch.045d238f.svg";